<script>
  export default {
    components: { },
    props: ['size']
  }
</script>

<template>
  <div id="card-loader">
    <div class="card" :class="{[size]: true}"></div>
    <div class="card" :class="{[size]: true}"></div>
    <div class="card" :class="{[size]: true}"></div>
  </div>
</template>

<style lang="scss">
@import "~@/styles/constants";
#card-loader{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  .card{
    position: relative;
    flex-basis: 30rem;
    height: 32rem;
    min-height: 32rem;
    margin: 1rem;
    border-radius: 0.5rem;
    transition: transform 0.3s ease;
    box-shadow: $z_depth_2;
    background-color: $card_background;
    opacity: 0;
    animation: fade 1.25s ease-in-out infinite;
    &.small{
      flex-basis: 24rem;
      width: 24rem;
      height: 26rem;
      min-width: 24rem;
      min-height: 26rem;
      margin: 0.75rem;
    }
    &:nth-child(1) {
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
  @keyframes fade {
    0%, 100% {
      opacity: 0; /* Fade out at the start and end */
    }
    50% {
      opacity: 1; /* Fade in at the halfway point */
    }
  }
}
</style>